import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

export const PrivateNoteTitle: FC = () => (
  <PanelHeaderTitle
    icon={<IconShell icon={<ViewOff16 />} />}
    title={
      <span data-cy="task_private_note.title">
        <FormattedMessage id="task.private_note.title" />
      </span>
    }
  />
);
